import React, { Component } from 'react';
import { trimStart } from 'lodash';
import PropTypes from 'prop-types';

class OrganizationIdRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      data, value,
    } = this.props;
    if (!data) {
      return null;
    }
    const org = data.organization || data;

    const isDemo = org.is_demo;
    if (isDemo || !value) {
      return null;
    }
    let display = value;
    if (org.type === 'azure') {
      display = trimStart(display, 'md-');
    } else if (org.type === 'hubspot') {
      display = trimStart(display, 'hs-');
    }

    return (
      <code>{display}</code>
    );
  }
}

OrganizationIdRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    is_demo: PropTypes.bool,
    type: PropTypes.string,
    organization: PropTypes.shape({}),
  }),
};
OrganizationIdRenderer.defaultProps = {
  value: null,
  data: null,
};

export default OrganizationIdRenderer;
